import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { AuthUser } from '../../../../core/models/auth/auth.interface';
import { AuthService } from '../../../../core/services/auth.service';
import { CommonModule } from '@angular/common';
import { UsersService } from '../../../../core/services/users.service';

import Swal from 'sweetalert2';
import { LoaderService } from '../../../../core/shared/services/loader.service';
import { USER_TYPES } from '../../../../core/shared/constants';


@Component({
  selector: 'app-auth-redirect',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './auth-redirect.component.html',
  styleUrl: './auth-redirect.component.scss'
})
export class AuthRedirectComponent implements OnInit {
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  authService = inject(AuthService);
  usersService = inject(UsersService);
  loader = inject(LoaderService);

  async ngOnInit(): Promise<void> {
    this.loader.show();

    try {
      // Obtener información de autenticación
      const authUser: AuthUser = this.authService.getAuthUser()!;
      const user = this.authService.getUser();

      console.log('AuthRedirect - AuthUser:', authUser);
      console.log('AuthRedirect - User:', user);

      if (!authUser || authUser.isNewUser) {
        // Usuario nuevo, redirigir a verificación
        await this.router.navigate(['/auth/verification'], {
          queryParams: { jwtUser: this.authService.getToken() }
        });
        return;
      }

      // Validar que el usuario tenga datos completos
      if (!user) {
        console.error('No se pudieron obtener los datos del usuario');
        await this.router.navigate(['/auth']);
        return;
      }

      // Usar el nuevo método de validación del servicio de autenticación
      const redirectRoute = await this.authService.validateAndRedirectAfterLogin(user);
      
      console.log('AuthRedirect - Redirigiendo a:', redirectRoute);
      await this.router.navigate([redirectRoute]);

    } catch (error) {
      console.error('Error en redirección:', error);
      // Manejar el error redirigiendo a una página segura
      await this.router.navigate(['/auth']);
    } finally {
      this.loader.hide();
    }
  }
}
